export const routes = {
  session: {
    welcome: '/session/welcome',
    signin: '/session/signin',
    signup: {
      name: '/session/signup',
      cpf: '/session/signup/cpf',
      cpfTaken: '/session/signup/cpf-taken',
      email: '/session/signup/email',
      code: '/session/signup/code',
      password: '/session/signup/password',
    },
    passwordRecovery: '/session/password-recovery',
    createPassword: '/session/create-password',
    confirmEmail: '/session/confirm-email',
    profile: {
      area: '/session/profile/area',
      crm: '/session/profile/crm',
      situation: '/session/profile/situation',
      graduation: '/session/profile/graduation',
      origin: '/session/profile/origin',
    },
  },
  home: '/',
  account: '/account',
  accounting: {
    index: '/accounting',
    revenue: '/accounting/revenue',
    fiscalNotes: {
      index: '/accounting/fiscal-notes',
      issue: '/accounting/fiscal-notes/issue',
    },
    taxes: '/accounting/taxes',
    monthlyDocuments: '/accounting/monthly-documents',
    monthlyDocumentsUpload:
      '/accounting/monthly-documents/:document_request_key/upload',
    additionalServices: '/accounting/additional-services',
    insurance: '/accounting/insurance',
    insuranceRcpQuote: '/accounting/insurance/rcp-medicos',
    referAndEarn: '/accounting/refer-and-earn',
    menu: '/accounting/menu',
    billing: '/accounting/billing',
    partners: {
      index: '/accounting/partners',
      data: '/accounting/partners/:partner_key/data',
      dependants: '/accounting/partners/:partner_key/dependants',
    },
    collaborators: '/accounting/collaborators',
    hiring: {
      index: '/accounting/hiring/:deal_key',
      proposal: '/accounting/hiring/:deal_key/proposal',
      preContract: '/accounting/hiring/:deal_key/pre-contract',
      mainPartner: '/accounting/hiring/:deal_key/main-partner',
      company: '/accounting/hiring/:deal_key/company',
      otherPartners: '/accounting/hiring/:deal_key/other-partners',
      documents: '/accounting/hiring/:deal_key/documents',
      contract: '/accounting/hiring/:deal_key/contract',
    },
  },
  credit: {
    index: '/credit',
    applications: '/credit/applications',
    application: '/credit/applications/:application_key/:step?',
    product: '/credit/products/:product',
    installments: '/credit/installments',
    contracts: '/credit/contracts',
    menu: '/credit/menu',
  },
}
